import { useContext } from 'react';
import equals from 'lodash.isequal';

// components
import { Image } from 'components/image/image';

// utils
import { interactiveDescriptionOpen } from './tracking-actions';
import { InteractiveDescriptionContext } from './context';
import { useTracking } from 'utils/hooks/useTracking';
import { useTracking as useTracking2 } from 'utils/tracking/track';

export function Points() {
  const track = useTracking();
  const { trackClick } = useTracking2();
  const { clickedItem, setClickedItem, setContentWhenClicked, imageMap } = useContext(
    InteractiveDescriptionContext,
  );

  if (imageMap === null) {
    return null;
  }

  const { areas, image, imageAlt, imageObject } = imageMap;

  const handleClick = (imageItem) => {
    const newClickedItem = areas.find((item) => equals(imageItem, item));
    if (!newClickedItem) {
      return;
    }

    const { description } = newClickedItem;
    const { headline } = description || {};

    setContentWhenClicked(description);
    setClickedItem(newClickedItem);

    if (headline) {
      track.trackEvent(interactiveDescriptionOpen(headline));
      trackClick({
        click_intent: 'more_info',
        click_text: headline,
        click_element: 'interactive_description',
      });
    }
  };
  const infoIcons = areas.map((imageItem) => {
    const linkHref = equals(imageItem, clickedItem)
      ? '/images/svg/icon-info-circle-full-blue.svg'
      : '/images/svg/icon-info-circle-full-white.svg';

    return (
      <image
        className="interactive-description__hotspot"
        key={`${imageItem.position.left}-${imageItem.position.top}`}
        xlinkHref={linkHref}
        width="35"
        height="35"
        x={imageItem.position.left}
        y={imageItem.position.top}
        onClick={() => handleClick(imageItem)}
      />
    );
  });

  return (
    <div className="interactive-description__image-wrapper small-12">
      <Image
        className="interactive-description__image"
        src={image}
        alt={imageAlt}
        title={imageAlt}
        data={imageObject}
      >
        <svg className="interactive-description__image-area">{infoIcons}</svg>
      </Image>
    </div>
  );
}
